import { render, staticRenderFns } from "./AssociationQuest.vue?vue&type=template&id=1836dfa7&scoped=true&"
import script from "./AssociationQuest.vue?vue&type=script&lang=js&"
export * from "./AssociationQuest.vue?vue&type=script&lang=js&"
import style0 from "./AssociationQuest.vue?vue&type=style&index=0&id=1836dfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836dfa7",
  null
  
)

export default component.exports